<template>
  <div v-if="options">
    <label :for="input.id" v-if="showLabel">{{ input.label }}
      <span v-if="input.required" class="text-danger">{{$t('form.required_star')}}</span>
    </label>

    <multiselect
      v-model="selfModel"
      :loading="loading"
      :class="[input.required ? 'required' : '']"
      :options="options"
      :allow-empty="input.allowEmpty"
      :preselect-first="input.preselectFirst"
      :multiple="input.multiple"
      :close-on-select="!input.multiple"
      :searchable="input.searchable"
      :placeholder="input.placeholder"
      :taggable="input.taggable"
      @search-change="debounceGetSelectOptions"
      @tag="value => {tag(input.name, value)}"
      @select="value => {select(input.name, value, input.multiple, false)}"
      @remove="value => {remove(input.name, value, input.multiple, true)}"
      :group-values="typeof input.group !== 'undefined' && input.group === false ? null : 'groupOptions'"
      :group-label="typeof input.group !== 'undefined' && input.group === false ? null : 'groupLabel'"
      :group-select="groupSelect"
      track-by="value"
      label="label"
      selectGroupLabel="Select All"
      deselectGroupLabel="X "
      select-label=""
      selected-label=""
      deselect-label="X "
      :disabled="disabled">
      <template slot="noResult">
        {{$t('global.no_results')}}
      </template>
    </multiselect>
  </div>
</template>

<script>
  import {pull} from 'lodash';

  export default {
    name: 'GroupSelect',
    props: {
      input: {
        type: Object
      },
      model: {
        require: true
      },
      disabled: {
        type: Boolean
      },
      props_options: {
        type: Array,
        default: () => []
      },
      groupSelect: {
        type: Boolean,
        default: false
      },
      showLabel: {
        type: Boolean,
        default: true
      },
      valueKey: {
        type: String,
        default: "id"
      },
      labelKey: {
        type: String,
        default: "title"
      },
      requestHeaders: {
        type: Object,
        default: null
      },
      disabledItems: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        loading: false,
        selfModel: [],
        modelMutated: [],
        options: [],
        debounceGetSelectOptions: () => {
        }
      }
    },
    computed: {
      items_key() {
        if (!this.input) return 'subscriptions';

        return this.input['items_key'] || 'subscriptions';
      }
    },
    mounted() {
      this.getSelectOptions();
      this.selfModel = this.model;
      this.debounceGetSelectOptions = _.debounce(this.getSelectOptions, 500);
    },
    methods: {
      getSelectOptions(value) {
        const queryParams = {filter: {}};
        if (this.input.static_filter) {
          queryParams.filter = {...this.input.static_filter}
        }
        if (value) {
          queryParams.filter[this.input.filter_field] = value;
        }
        const params = {params: queryParams, headers: {}}
        if (this.requestHeaders) {
          params.headers = this.requestHeaders;
        }
        if (this.input.options_url) {
          this.loading = true;
          this.getData(this.input.options_url, params).then(({data}) => {
            this.transformSelectOptions(data.items);
          }).then(()=> {
            this.$forceUpdate();
            this.loading = false;
          }).catch(e => {
            console.log(e);
            this.loading= false;
          })
        } else if (this.input.options){
          this.options = this.input.options
        } else {
          this.transformSelectOptions(this.props_options);
          this.$forceUpdate()
        }
      },
      transformSelectOptions(data) {
        if (typeof this.input.group !== "undefined" && this.input.group === false) {
          Promise.all(data.map(item => {
                if (typeof item.active === "undefined" || item.active === true) {
                  return {
                    label: item[this.labelKey],
                    value: item[this.valueKey],
                  }
                } else {
                  return {
                    label: item[this.labelKey],
                    value: item[this.valueKey],
                    $isDisabled: true
                  }
                }
              }
          )).then(result => {
            if(this.disabledItems.length > 0){
              return result.map((item) => {
                if(this.disabledItems.includes(item.value)){
                  item.$isDisabled = true;
                  return item;
                }
                return item;
              })
            }
            return result;
          }).then(result => {
            this.options = result;
            this.$forceUpdate();
          })
        } else {
          Promise.all(data.map(item => {
                return {
                  groupLabel: item.title,
                  groupOptions: item[this.items_key].map((subs) => {
                    if (!item.active || !subs.active) {
                      return {
                        label: subs.title,
                        value: subs.id,
                        $isDisabled: true
                      }
                    } else {
                      return {
                        label: subs.title,
                        value: subs.id
                      }
                    }
                  })
                }
              }
          )).then(result => {
            this.options = result;
            this.$forceUpdate();
          })
        }
      },
      tag(field, value) {
        this.$emit('tag', {field, value})
      },
      select(field, value, multiple, remove) {
        if (Array.isArray(value)) {
          for (let item of value.filter(val => !this.modelMutated.includes(val))) {
            this.modelMutated.push(item);
          }
        } else if (multiple) {
          this.modelMutated.push(value);
        } else {
          this.modelMutated = value
        }
        this.$emit('select', {field, value, multiple, remove})
      },
      remove(field, value, multiple, remove) {
        if (multiple && value) {
          if (Array.isArray(value)) {
            for (let item of value) {
              this.modelMutated = _.filter(this.modelMutated, (currentObject) => {
                return currentObject.value !== item.value
              })
            }
          } else {
            pull(this.modelMutated, value.value);
          }
        }
        this.$emit('remove', {field, value, multiple, remove})
      }
    },
    watch: {
      model(value) {
        this.selfModel = value;
        this.modelMutated = [];
      },
    }
  }
</script>
